<template>
  <select
      v-bind:name="name"
      class="form-control"
      v-bind:multiple="multiple"
      v-bind:disabled="disabled"
      v-bind:required="required"
  >
  </select>
</template>

<script>
  import $ from 'jquery';
  import 'select2';
  import '../../plugins/select2-ru';
  import { Auth } from "../../api";

  export default {
    props: {
      name: '',
      options: {
        Object
      },
      presetValue: null,
      value: null,
      multiple: {
        Boolean,
        default: false
      },
      required: {
        Boolean,
        default: false
      },
      disabled: {
        Boolean,
        default: false
      },
      uri: {
        String
      },
      field: {
        String,
        default: 'name'
      },
      limit: {
        Number,
        default: 30
      },
      text: Function,
      placeholder: String,
      allowClear: Boolean,
      notId: {
        Boolean,
        default: false
      },
      addRequestParams: Object,
      dropdownParentSelector: String
    },
    data() {
      return {
        select2data: [],
        currentPage: 1
      }
    },
    watch: {
      presetValue: function () {
        this.init();
      },
      options: function () {
        this.init();
      },
      value: function (val) {
        let isSameArrays = (array1, array2) => {
          return array1.length === array2.length && array1.every((item, index) => {
            return array1[index] === array2[index];
          });
        };
        let valEl = $(this.$el).val();
        if (Array.isArray(val) && Array.isArray(valEl)) {
          if (!isSameArrays(val, valEl))
            return this.init();
        }
        else {
          if (valEl !== val)
            return this.init();
        }
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        let vm = this;
        let select = $(this.$el);
        let ajax;
        if (this.uri)
          ajax = this.getAjaxConfig();
        let presetValue = this.getPresetValue();
        $(select).empty();
        select
          .select2({
            placeholder: this.placeholder,
            theme: 'material',
            width: '100%',
            allowClear: this.allowClear,
            data: ajax && presetValue ? presetValue : this.options || [],
            dropdownParent: this.dropdownParentSelector ? $(this.dropdownParentSelector) : $(this.$el).parent(),
            language: "ru",
            ajax
          })
          .on('change', function () {
            vm.$emit('input', select.val())
          });
        select.val(this.value).trigger('change')
      },
      getPresetValue() {
        let presetValue = this.presetValue;
        if (presetValue && !Array.isArray(presetValue))
          presetValue = [
            this.notId ? { id: presetValue, text: presetValue } : { id: presetValue.id, text: this.getText(presetValue) }
          ];
        else if (presetValue) {
          presetValue = presetValue.map(item => {
            return this.notId ? { id: presetValue, text: presetValue } : { id: item.id, text: this.getText(item) };
          });
        }
        return presetValue;
      },
      getAjaxConfig() {
        return {
          url: process.env.VUE_APP_ROOT_API + this.uri,
          data: (params) => {
            this.currentPage = params.page || 1;
            return {
              [this.field]: params.term,
              limit: this.limit,
              offset: this.limit * (this.currentPage - 1),
              ...this.addRequestParams
            }
          },
          headers: {
            "Authorization" : `Bearer ${Auth.token}`,
            "Content-Type" : "application/json"
          },
          processResults: (data) => {
            return {
              results: data.rows.map(item => {
                if (this.notId)
                  return {
                    id: this.getText(item),
                    text: this.getText(item)
                  };
                return {
                  id: item.id,
                  text: this.getText(item)
                }
              }),
              pagination: {
                more: this.limit * this.currentPage < data.count
              }
            };
          }
        }
      },
      getText(item) {
        if (typeof this.text === 'function')
          return this.text(item);
        else
          return item[this.field];
      }
    }
  }
</script>

<style scoped>

</style>
